import React from 'react';
import SystemsChart from './Charts/SystemsChart';
import AfricaChoroplethMap from './Charts/Map/AfricaMap';
import CountDisplay from './CountDisplay';
import PolicyDurationDisplay from './DurationDisplay';

function PolicyWins({policyWinsTab, setPolicyWinsTab, data, countryID, setCountryID}) {

    const labelMap = {
        policy_distribution : {
            id: 1,
            dataField: 'number_of_policies',
            textField: 'Policies'
        }, 
        time_analysis: {
            id: 2,
            dataField: 'average_month_duration',
            textField: 'Time duration in months'
        }
    }

    const label = labelMap[policyWinsTab]; //TODO: add useEffect to update only when subTab changes
    //TODO: Make common labelMap if data pattern matches

    return (
        <>
            <div className='d-flex justify-center'>
                <div className={`sub-tab mx-1 ${policyWinsTab === 'policy_distribution' ? 'sub-tab-active' : ''}`} onClick={()=>setPolicyWinsTab('policy_distribution')}>Policy Distribution</div>
                <div className={`sub-tab mx-1 ${policyWinsTab === 'time_analysis' ? 'sub-tab-active' : ''}`} onClick={()=> setPolicyWinsTab('time_analysis')}>Time Analysis</div>
            </div>
            {data &&
                <div id="print-content">
                    {
                        policyWinsTab === 'policy_distribution' ? 
                            <CountDisplay title = {'Total number of policies'} count={data?.total_number_of_policies}/>
                            : <PolicyDurationDisplay data={data?.average_duration}/>
                    }
                    <div className='flex space-x-3 justify-center'>
                        <AfricaChoroplethMap chartData={data?.location?.data} countryID={countryID} setCountryID={setCountryID} label={label}/>
                        <SystemsChart chartData={data?.system?.data} label={label}/>
                    </div>
                </div>
            }
        </>
    );
}

export default PolicyWins;